import React, { ReactElement } from 'react';
import * as rewardsTransactionsHistoryStyle from '../../rewardsTransactionsHistoryStyles';

export interface ITransactionTableItem {
    buttonText: ReactElement | string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    selected: boolean;
    uniqueKey: string;
}

interface ITransactionTableMenuProps {
    items: ITransactionTableItem[];
    disabled?: boolean;
}

const DATA_QA_ID = 'rewards-transaction-history-table-menu-btn';

export const TransactionTableNavMenu = ({
    items,
    disabled = false,
}: ITransactionTableMenuProps) => {
    return (
        <>
            {items.map((item, i) => {
                return (
                    <rewardsTransactionsHistoryStyle.RewardButton
                        data-qa-id={DATA_QA_ID + '-' + i}
                        key={item.uniqueKey}
                        className={item.selected ? 'selected' : ''}
                        onClick={item.onClick}
                        disabled={disabled}
                    >
                        {item.buttonText}
                    </rewardsTransactionsHistoryStyle.RewardButton>
                );
            })}
        </>
    );
};
